
<form autocomplete="off" :class="classes">
  <slot></slot>
  <!-- 防止一个input enter提交form 刷新页面 -->
  <input type="text" autocomplete="off" style="display: none" />
</form>
